import React from "react"
import GUI from "../GUI"
import Button, { TButtonProps } from "./Button"
export default function IconButton(props:TButtonProps){
    const {className,children,...buttonProps} = props
    return <Button className={GUI.joinClass("icon", className)} {...buttonProps}>{children}</Button>
}